<template>
	<div class="userHome f-bct animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<template v-if="userType==1">
			<!-- 审核状态 -->
			<div class="shStatus f-ct" @click="link('/userMsg')" v-if="manInfo.auditStatus==0">
				<el-image class="i1" :src="require('@/static/icon110.png')"></el-image>
				<el-image class="i2" :src="require('@/static/icon111.png')"></el-image>
				<p>审核状态：审核中</p>
			</div>
			<div class="shStatus f-ct" @click="link('/userMsg')" style="background: #FF5F5A;" v-if="manInfo.auditStatus==2">
				<el-image class="i1" :src="require('@/static/icon110.png')"></el-image>
				<el-image class="i2" :src="require('@/static/icon111.png')"></el-image>
				<p>审核状态：审核不通过&emsp;原因：{{manInfo.auditInfo}}</p>
			</div>
		</template>
		<div class="pagel">
			<!-- 轮播图 -->
			<div class="banner">
				<el-carousel height="2.22rem" @change="bannerC" ref="carousel" indicator-position="none" :autoplay="true">
				    <el-carousel-item v-for="item in userInfo.bannerList" :key="item">
						<el-image class="icon" fit="cover" :src="item.picture"></el-image>
				    </el-carousel-item>
				</el-carousel>
				<div class="dian f-ct">
					<div @click="bannerDian(index)" :class="bannerIdx==index?'a':''" v-for="(item,index) in userInfo.bannerList" :key="item"></div>
				</div>
			</div>
			<!-- 课堂信息 -->
			<div class="classMsg" v-if="userType==1">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon46.png')"></el-image>
					<p>课程信息</p>
				</div>
				<div class="anniuBox f-bct">
					<div class="itm tag1" @click="link('/userOrder')">
						<el-image :src="require('@/static/icon47.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.unpayTotalPrice}}</p>
							<p class="t2">待缴费</p>
						</div>
					</div>
					<div class="itm tag2" @click="link('/classList')">
						<el-image :src="require('@/static/icon48.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.notCompleteStudyNum}}</p>
							<p class="t2">学习中</p>
						</div>
					</div>
					<div class="itm tag3" @click="link('/examList')">
						<el-image :src="require('@/static/icon49.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.waitExamNum}}</p>
							<p class="t2">待考试</p>
						</div>
					</div>
					<div class="itm tag4" @click="link('/userMsg',{type:2})">
						<el-image :src="require('@/static/icon50.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.certificateNum}}</p>
							<p class="t2">已发证</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 员工统计 -->
			<div class="classMsg" v-if="userType==2">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon46.png')"></el-image>
					<p>员工统计</p>
				</div>
				<div class="anniuBox f-bct">
					<div class="itm2 tag1" @click="link('/qyStaff')">
						<el-image :src="require('@/static/icon47.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.todayMemberCount}}</p>
							<p class="t2">今日新增员工(人)</p>
						</div>
					</div>
					<div class="itm2 tag2" @click="link('/qyStaff')">
						<el-image :src="require('@/static/icon48.png')"></el-image>
						<div class="txt">
							<p class="t1">{{userInfo.memberCount}}</p>
							<p class="t2">现有总员工(人)</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 推荐课程/热门课程 -->
			<div class="course">
				<div class="navBox f-ct">
					<p @click="newsType=1,courselistGet()" :class="newsType==1?'a':''">推荐课程</p>
					<p @click="newsType=2,courselistGet()" :class="newsType==2?'a':''">热门课程</p>
					<p @click="newsType=3,courselistGet()" :class="newsType==3?'a':''">全部课程</p>
				</div>
				<div class="courseList f-ct">
					<div class="item" @click="link('/userCourseMsg',{id:item.id})" v-for="(item,index) in courseArr">
						<div class="name line1">{{item.name}}</div>
						<div class="tag line2">- 课程类型：{{item.categoryName}}</div>
						<div class="price f-bct">
							<!-- <div class="priceNbu">￥{{item.price}}</div> -->
							<div class="anniu f-ct">
								<p>了解更多</p>
								<el-image :src="require('@/static/icon51.png')"></el-image>
							</div>
						</div>
					</div>
				</div>
				
				<div class="fenye" style="margin-top: 0;">
				<el-pagination
				background
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
				</div>
				
			</div>
		</div>
		<div class="pager">
			<!-- 学员信息 -->
			<div class="umsg" v-if="userType==1">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon52.png')"></el-image>
					<p>学员信息</p>
				</div>
				<div class="detail flex">
					<el-image fit="cover" :src="userInfo.member.portrait"></el-image>
					<div class="detailR">
						<div>学员账号：  <span>{{userInfo.member.invitationCode}}</span></div>
						<div>手机号码：  <span>{{userInfo.member.mobile}}</span></div>
						<div>工作单位：  <span>{{userInfo.member.companyName}}</span></div>
					</div>
				</div>
			</div>
			<div class="umsg" v-if="userType==2">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon52.png')"></el-image>
					<p>企业信息</p>
				</div>
				<div class="detail flex">
					<el-image :src="userInfo.company.logo"></el-image>
					<div class="detailR">
						<div><span>{{userInfo.company.companyName}}</span></div>
						<div>社会统一信用代码：  <span>{{userInfo.company.companyCreditCode}}</span></div>
						<div>企业地址：  <span>{{userInfo.company.provinceName}}{{userInfo.company.cityName}}{{userInfo.company.districtName}}{{userInfo.company.address}}</span></div>
					</div>
				</div>
			</div>
			
			<div class="tongzhi f-bct">
				<el-image class="i1" :src="require('@/static/tz1.png')"></el-image>
				<div class="txtbox">
					<el-carousel height="0.68rem" direction="vertical" ref="carousel1" indicator-position="none" :autoplay="true">
					    <el-carousel-item v-for="item in noticeNewsList">
							<div class="tongzhiMsg">
								<div class="txtBox line1" @click="link('/tongzhiMsg',{id:item.noticeId})">{{item.noticeTitle}}</div>
							</div>
					    </el-carousel-item>
					</el-carousel>
				</div>
				<el-image class="i3" @click="link('/tongzhiList')" :src="require('@/static/icon55.png')"></el-image>
			</div>
			
			<!-- 最新系统消息 -->
			<div class="news">
				<div class="tit f-bct">
					<div class="l f-ct">
						<el-image :src="require('@/static/icon53.png')"></el-image>
						<p>学员信息</p>
					</div>
					<div class="r f-ct" @click="link('/userNews')">
						<p>历史消息</p>
						<el-image :src="require('@/static/icon54.png')"></el-image>
					</div>
				</div>
				<div class="newsList">
					<div class="zw" style="padding-top: 0.8rem;" v-if="!messageArr.length">
						<el-image :src="require('@/static/zw.png')"></el-image>
						<p>暂无相关数据...</p>
					</div>
					<div class="newsItm" @click="messageRead(item,index)" v-for="(item,index) in messageArr">
						<div class="newTit f-bct">
							<div class="l f-ct">
								<p class="bor" v-if="!item.lookStatus"></p>
								<span>{{item.message.title}}</span>
							</div>
							<div class="r">{{gsTime(item.createTime)}}</div>
						</div>
						<div class="newTxt line1">
							{{item.message.content}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { messagememberMessageList,
messagecompanyMessageList,
authMemberInfo,
authCompanyInfo,
courselist,
messagecompanyRead,
messagememberRead,
homeIndex,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			newsType:1,
			bannerIdx:0,
			// 分页
			pageNum:1,
			pageSize:6,
			total:0,
			// 消息列表
			messageArr:[],
			// 课程列表
			courseArr:[],
			// 通知
			noticeNewsList:[],
			manInfo:''
		}
	},
	mounted() {
		this.messageListGet()
		this.getinfo()
		this.courselistGet()
		this.homeIndex()
		if(this.userType==1){
			this.getinfoA()
		}
	},
	methods:{
		// 获取用户信息 学员
		async getinfoA(){
			let res;
			res = await authMemberInfo({});
			if(res.code==200){
				this.manInfo = res.data.member
			}else{this.Tips(res.msg,'error')}
		},
		// 获取首页数据
		async homeIndex(){
			let res = await homeIndex({});
			if(res.code==200){
				this.noticeNewsList = res.data.noticeList
				console.log(this.noticeNewsList)
			}else{this.Tips(res.msg,'error')}
		},
		// 阅读消息
		async messageRead(item,index){
			let res;
			if(this.userType==1){
				var data = {messageMemberId:item.id}
				res = await messagememberRead(data);
			}
			if(this.userType==2){
				var data = {messageCompanyId:item.id}
				res = await messagecompanyRead(data);
			}
			if(res.code==200){
				item.lookStatus = 1
				this.$set(this.messageArr,index,item)
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courselistGet()
		},
		// 查询课程列表
		async courselistGet(def){
			if(def){
				this.pageNum = 1
			}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				orderByColumn:'id',
				isAsc:'desc'
			}
			if(this.newsType==1){
				data.isHome = 1
			}
			if(this.newsType==2){
				data.isHot = 1
			}
			const res = await courselist(data);
			if(res.code==200){
				// this.courseArr = res.rows
				if(this.pageNum==1){
					this.total = res.total
				}
				this.courseArr = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 查询消息列表
		async messageListGet(){
			let res;
			var data = {
				pageSize: 10,
				pageNum: 1,
			}
			// 学员
			if(this.userType==1){
				res = await messagememberMessageList(data);
			}
			// 企业
			if(this.userType==2){
				res = await messagecompanyMessageList(data);
			}
			if(res.code==200){
				res.rows.forEach((item)=>{
					item.message.content = item.message.content.replace(/<.*?>/g,"")
				})
				this.messageArr = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			let res;
			// 学员
			if(this.userType==1){
				res = await authMemberInfo({});
			}
			// 企业
			if(this.userType==2){
				res = await authCompanyInfo({});
			}
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
			}else{this.Tips(res.msg,'error')}
		},
		// 轮播图
		bannerC(e){
			this.bannerIdx = e
		},
		bannerDian(index){
			this.$refs.carousel.setActiveItem(index)
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.shStatus{
	width: 100%;
	height: 60px;
	padding: 0 23px;
	position: relative;
	background: #3B6492;
	margin-bottom: 23px;
	.i1{
		position: absolute;
		width: 100%;
		height: 60px;
		left: 0;
		top: 0;
	}
	.i2{
		width: 28px;
		margin-right: 8px;
	}
	p{
		font-size: 14px;
		color: #fff;
	}
}
.userHome{
	align-items: stretch;
	padding: 0 40px;
	.pagel{
		width: 994px;
		position: relative;
		.banner{
			width: 100%;
			height: 222px;
			.el-image{
				border-radius: 20px;
			}
			.dian{
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				bottom: 16px;
				z-index: 2;
				div{
					margin: 0 3px;
					width: 8px;
					height: 8px;
					border-radius: 8px;
					background: #00000033;
					transition:0.3s;
				}
				.a{
					background: #3B6492;
					width: 14px;
					transition:0.3s;
				}
			}
		}
		.classMsg{
			background: #fff;
			margin-top: 24px;
			border-radius: 20px;
			padding: 0 24px;
			padding-bottom: 24px;
			.tit{
				padding: 24px 0;
				.el-image{
					width: 40px;
					height: 40px;
					margin-right: 12px;
				}
				p{
					font-size: 18px;
					font-weight: 500;
				}
			}
			.anniuBox{
				.itm2{
					cursor: pointer;
					width: 462px;
					height: 104px;
					border-radius: 12px;
					padding: 20px 20px;
					display: flex;
					align-items: center;
					.el-image{
						width: 64px;
						height: 64px;
						margin-right: 16px;
					}
					.txt{
						width: calc(100% - 80px);
						.t1{
							font-size: 24px;
							font-weight: bold;
							color: #3B6492;
						}
						.t2{
							font-size: 16px;
						}
					}
				}
				.itm{
					cursor: pointer;
					width: 224px;
					height: 104px;
					border-radius: 12px;
					padding: 20px 20px;
					display: flex;
					align-items: center;
					.el-image{
						width: 64px;
						height: 64px;
						margin-right: 16px;
					}
					.txt{
						width: calc(100% - 80px);
						.t1{
							font-size: 24px;
							font-weight: bold;
							color: #3B6492;
						}
						.t2{
							font-size: 16px;
						}
					}
				}
				.tag1{
					background: #FFEEE4;
				}
				.tag2{
					background: #E5F1FF;
				}
				.tag3{
					background: #FFE4DE;
				}
				.tag4{
					background: #D2FAFF;
				}
			}
		}
		.course{
			background: #fff;
			margin-top: 24px;
			border-radius: 20px;
			padding: 0 14px;
			padding-bottom: 14px;
			.navBox{
				border-bottom: 1px solid #EEEEEE;
				// height: 62px;
				
				padding: 0 10px;
				p{
					padding-bottom: 13px;
					margin-right: 33px;
					font-size: 18px;
					font-weight: bold;
					cursor: pointer;
					color: #333;
					padding-top: 24px;
					&::after{
						position: absolute;
						content: '';
						width: 0%;
						height: 4px;
						border-radius: 4px;
						background: #3B6492;
						bottom: 0%;
						left: 50%;
						transform: translateX(-50%);
						transition:0.3s;
					}
				}
				.a{
					color: #3B6492;
					font-weight: bold;
					&::after{
						width: 100%;
						transition:0.3s;
					}
				}
			}
			.courseList{
				padding-top: 24px;
				.item{
					background: #F3F9FF;
					border-radius: 16px;
					width: 302px;
					height: 160px;
					margin: 0 10px;
					margin-bottom: 20px;
					padding: 20px;
					.name{
						font-size: 18px;
						// height: 60px;
						line-height: 28px;
						font-weight: bold;
					}
					.tag{
						font-size: 14px;
						height: 40px;
						margin-top: 10px;
						color: #545964;
						margin-top: 8px;
					}
					.price{
						margin-top: 10px;
						.priceNbu{
							font-size: 20px;
							color: #FF5F5A;
							font-weight: 600;
						}
						.anniu{
							width: 90px;
							height: 36px;
							background: #3B6492;
							border-radius: 6px;
							justify-content: center;
							cursor: pointer;
							p{
								font-size: 14px;
								color: #fff;
							}
							.el-image{
								width: 16px;
								height: 16px;
							}
						}
					}
				}
			}
		}
	}
	.pager{
		width: 556px;
		.umsg{
			width: 100%;
			// height: 222px;
			border-radius: 20px;
			padding: 24px;
			background: #fff;
			.tit{
				padding-bottom: 24px;
				.el-image{
					width: 40px;
					height: 40px;
				}
				p{
					font-size: 18px;
					font-weight: bold;
					padding-left: 12px;
				}
			}
			.detail{
				.el-image{
					width: 110px;
					height: 110px;
					border-radius: 12px;
					margin-right: 18px;
				}
				.detailR{
					width: calc(100% - 128px);
					div{
						margin-top: 12px;
						font-size: 16px;
						color: #999999;
						line-height: 28px;
						&:first-child{
							margin-top: 0;
						}
						span{
							color: #333333;
						}
					}
				}
			}
		}
		.tongzhi{
			width: 100%;
			height: 68px;
			margin-top: 24px;
			// padding: 24px;
			padding: 0 24px;
			background: #fff;
			.txtbox{
				width: calc(100% - 73px);
				.tongzhiMsg{
					padding: 24px 3px;
					font-size: 16px;
					transform: translateY(-1px);
					cursor: pointer;
				}
			}
			.i1{
				width: 43px;
				height: 20px;
			}
			.i3{
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
			
		}
		.news{
			margin-top: 24px;
			width: 100%;
			background: #fff;
			padding: 24px;
			border-radius: 20px;
			.tit{
				// padding-bottom: 24px;
				.l{
					.el-image{
						width: 40px;
						height: 40px;
					}
					p{
						font-size: 18px;
						font-weight: bold;
						padding-left: 12px;
					}
				}
				.r{
					cursor: pointer;
					.el-image{
						width: 18px;
						height: 18px;
					}
					p{
						font-size: 16px;
						color: #3B6492;
					}
				}
			}
			.newsList{
				height: 640px;
				overflow: scroll;
			}
			.newsItm{
				height: 100px;
				border-bottom: 1px solid #DDDDDD;
				padding: 20px 0;
				cursor: pointer;
				.newTit{
					.l{
						.bor{
							width: 10px;
							height: 10px;
							border-radius: 50%;
							margin-right: 8px;
							background: #F26161;
						}
						span{
							font-size: 18px;
							// color: #333333;
						}
					}
					.r{
						font-size: 16px;
						color: #999999;
					}
				}
				.newTxt{
					color: #666666;
					font-size: 16px;
					margin-top: 14px;
				}
			}
		}
	}
}
</style>